import { ReactElement } from 'react'
import {
    ServiceCardContainer,
    CoverageButton,
    ImageWrapper,
    StyledServiceCard,
} from './styles'
import { ServiceCardProps } from './props'
import { Button, Grid, Heading, Image, Text } from '../..'
import { SVG } from '../../Atoms'
import { ChevronRightCircle, ChevronRight } from '../../Assets/Icons'

const ServiceCard = ({
    ['data-cy']: dataCy,
    buttonText,
    disabled = false,
    icon,
    name,
    noCoverage,
    noCoverageText,
    onNoCoverageClick,
    text,
    ...props
}: ServiceCardProps): ReactElement => {
    return (
        <ServiceCardContainer>
            <StyledServiceCard {...props} disabled={disabled}>
                <ImageWrapper disabled={disabled}>{icon}</ImageWrapper>
                <Grid>
                    <Heading level={3} size={5} bold>
                        {name}
                    </Heading>
                    {text && <Text size="s">{text}</Text>}
                </Grid>
                <Button
                    data-cy={dataCy}
                    disabled={disabled}
                    variant={{ '@mobile': 'default', '@desktop': 'option' }}
                >
                    {buttonText}
                    <SVG src={ChevronRight} />
                </Button>
            </StyledServiceCard>
            {noCoverage && (
                <CoverageButton>
                    <Button
                        onClick={onNoCoverageClick}
                        endIcon={<SVG src={ChevronRightCircle} />}
                    >
                        {noCoverageText}
                    </Button>
                </CoverageButton>
            )}
        </ServiceCardContainer>
    )
}

export default ServiceCard

export { StyledServiceCard }
